import type { ReactNode } from 'react';

export const symbol_family_home: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M490.13-261q5.13-2 9.87-6 18-16 43.5-41t49-54q23.5-29 40.5-59.5t17-56.5q0-38.82-25.5-64.41Q599-568 560-568q-23 0-44 11.5T480-529q-15-16-36.08-27.5T400.35-568q-39.35 0-64.85 25.59Q310-516.82 310-478q0 26 17 56.5t40.5 59.5q23.5 29 49 54t43.5 41q4.74 4 9.87 6 5.13 2 10.13 2 5 0 10.13-2ZM220-120q-24.75 0-42.37-17.63Q160-155.25 160-180v-341l-60 46q-10.35 8-22.17 6Q66-471 58-481q-8-10-6.06-22.19Q53.89-515.38 64-523l380-289q8-6 17-9.5t19-3.5q10 0 19 3.5t17 9.5l381 290q9.94 7.62 11.47 19.81Q910-490 902-479.63q-8 9.63-19.5 11.13T861-475l-61-46v341q0 24.75-17.62 42.37Q764.75-120 740-120H220Zm0-60h520v-387L480-765 220-567v387Zm0 0h520-520Z"
		/>
	</svg>
);
